import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  status: "idle",
  user: null,
  loading: false,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // CUSTOM
    resetState: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      axios.defaults.headers.common["Authorization"] = `Bearer ${action.payload.token}`;
    },

    // LOGIN
    loginFetch: (state) => {
      state.loading = true;
      state.user = null;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = null;
    },
    loginError: (state, action) => {
      state.loading = false;
      state.user = null;
      state.error = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export const authReducers = authSlice.reducer;
